import React from 'react';
import { withTranslation } from 'react-i18next';
import { FaIcon } from '../FaIcon';

function formatNumber(value) {
    if (value === null || value === undefined) return '-';
    return Number(value).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
}

function ConversionsCellComponent({ conversions }) {
    if (!conversions || conversions.total === null || conversions.total === undefined) {
        return <span className="conversions-empty">—</span>;
    }

    const byAction = conversions.by_action || {};
    const actionNames = Object.keys(byAction);

    return (
        <div className="conversions-cell">
            <span className="conversions-total">{formatNumber(conversions.total)}</span>
            {actionNames.length > 0 && (
                <div className="info-icon-container">
                    <FaIcon iconName="info-circle"/>
                    <div className="warning-tooltip -rich">
                        <div className="warning-tooltip-body">
                            {actionNames.map((name) => {
                                const entry = byAction[name];
                                const count = entry && entry.total !== undefined ? formatNumber(entry.total) : '-';
                                return (
                                    <div key={name} className="warning-tooltip-text">
                                        <strong>{name}:</strong> {count}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export const ConversionsCell = withTranslation()(ConversionsCellComponent);
